import React, { useEffect } from "react";
import { Space, Form, Radio, notification } from "antd";
import { CustomButton, CustomRadio } from "../index";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import httpClient from "../../api/module/httpClient";
import { useHistory, useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import CustomInput from "../Input";

/**
 *
 * do not remove values, just add them as this is the source of truth for the questions
 * if should we retire a question, we just add an indicator that the question is not being used anymore
 * so we can keep track of the question using the id in the backend
 */
const questions = [
  {
    id: 1,
    question: "Question 1",
    type: "radio",
  },
  {
    id: 2,
    question: "Question 2",
    type: "radio",
  }, {
    id: 3,
    question: "Question 3",
    type: "radio",
  },
  {
    id: 4,
    question: "Question 4",
    type: "radio",
  },{
    id: 5,
    question: "Question 5",
    type: "text",
  },
];

export default function CertificateClassFeedbackReview() {
  const [form] = Form.useForm();

  const { classId, certificateId } = useParams();
  const { search } = useLocation();
  const parsed = queryString.parse(search);

  const queryClient = useQueryClient();

  const submitReviewMutation = useMutation({
    mutationFn: async ({ review, id }) => {
      return httpClient.post(`private/certificate-class/feedback-review`, { review, id, classId, certificateId });
    },
    onSuccess: () => {
      notification.success({
        message: "Success",
      });

      queryClient.invalidateQueries(["FEEDBACK_REVIEW", classId, certificateId]);
      form.resetFields();
    },
    onError: () => {
      notification.error({
        message: "Something went wrong",
      });
      form.resetFields();
    },
  });

  const { data } = useQuery({
    queryKey: ["FEEDBACK_REVIEW", classId, certificateId],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/course/${certificateId}/certificate-class/${classId}/feedback-review`);

      return data;
    },
  });

  useEffect(() => {
    form.resetFields();
  }, [form, data]);


  function handleSubmit(values) {
    const { id, ...rest } = values;
    const ids = Object.keys(rest);

    ids.forEach(id => {
      const questionItem = questions.find((question) => question.id === +id);

      rest[id] = {
        rating: rest[id],
        ...questionItem,
      };

    });

    submitReviewMutation.mutate({ review: Object.values(rest), id });
  }

  const initialValues = (data?.review ?? []).map(data => ({
    id: data?.id || null,
    [data.id]: data.rating,
  })).reduce((acc, curr) => {
    const key = Object.keys(curr)[0];
    acc[key] = curr[key];
    return acc;
  }, {});


  return (
    <div style={{ width: "50%", margin: "auto", marginTop: "1rem" }}>
      <Form form={form} onFinish={handleSubmit} layout="vertical" initialValues={initialValues}>
        <Form.Item hidden={true} name="id" initialValue={data?.id || null} />
        <h2>{parsed.classTitle.split("-").join(" ")} - Feedback Review</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "2rem", marginTop: "1rem" }}>
          {questions.map(({ question, id, type }) => {
            return (
              <>
                {type === "radio" && (
                  <Form.Item
                    name={id}
                    key={question}
                    label={question}
                    rules={[{ required: true, message: "Input is required." }]}
                  >
                    <Radio.Group style={{ display: "flex", marginTop: "1rem" }}>
                      {[1, 2, 3, 4, 5].map(rating => <CustomRadio value={rating}>{rating}</CustomRadio>)}
                    </Radio.Group>
                  </Form.Item>
                )}
                {type === "text" && (
                  <Form.Item
                    name={id}
                    key={question}
                    label={question}
                    rules={[{ required: true, message: "Input is required." }]}
                  >
                    <CustomInput multiple={true} />
                  </Form.Item>
                )}
              </>
            );
          })}
        </div>
        <Form.Item>
          <CustomButton text="Submit" htmlType="submit" />
        </Form.Item>
      </Form>
    </div>
  );
}